/**
 * Intensity — the Pod's points-demand target (system-design §6.2.5). Raised
 * from a fixed 8-level ceiling to 20 so RMs can express heavier engagements
 * without inventing a second scale.
 */
export const INTENSITY_MAX = 20;

/**
 * The graduated color ramp (`design-system/tokens.css`) only defines 8 stops
 * (`--intensity-1` … `--intensity-8`). Levels above 8 band to the darkest
 * existing stop rather than inventing new tokens — do not add `--intensity-9`
 * and beyond to tokens.css for this.
 */
export function intensityColorVar(level: number): string {
  const n = Math.min(8, Math.max(1, level));
  return `var(--intensity-${n})`;
}
